
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog, Datetime, MylobyAutocomplete },
})
export default class MissionOrderDelegateModal extends Vue {

    @Prop({default: null})
    public missionOrderId: number;

    @Prop({default: null})
    public initialDelegatedCompany: any;

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;

    private showDialog: boolean = true;
    private loading: boolean = false;
    private delegatedCompanyId: number = null;

    get isFormValid(): boolean {
      return (this.initialDelegatedCompany?.id || null) !== (this.delegatedCompanyId || null);
    }

    private mounted(): void {
      this.reset();
    }

    private reset(): void {
      this.delegatedCompanyId = this.initialDelegatedCompany?.id;
    }

    private close(): void {
      this.showDialog = false;
      this.$emit("close");
      this.reset();
    }

    private async delegateMissionOrder(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("missionOrders/delegate", {
            id: this.missionOrderId,
            delegatedCompanyId: this.delegatedCompanyId,
        }).then(() => {
            this.showDialog = false;
            this.$emit("reset");
            this.reset();
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n.t("MissionOrders.delegated"),
            });
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }
}
